import { render, staticRenderFns } from "./ErrorSentForSigning.vue?vue&type=template&id=56cda998&"
import script from "./ErrorSentForSigning.vue?vue&type=script&lang=ts&"
export * from "./ErrorSentForSigning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports